export default __webpack_public_path__ + "static/media/img_0_0.d352b4b6.png";